import { PickupLocation } from "@redotech/redo-model/return";
import { PickupPayer } from "@redotech/redo-model/return-flow";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

const pickupInputSchema = z.object({
  pickupDate: z.string(),
  pickupLocation: createEnum(PickupLocation),
  specialInstructions: z.string().optional(),
  pickupPayer: createEnum(PickupPayer),
  textReminder: z.boolean(),
  pickupReadyTime: z
    .object({ hours: z.number(), minutes: z.number() })
    .optional(),
});

export const scheduleReturnPickup = {
  name: "scheduleReturnPickup" as const,
  input: z.object({
    returnId: zExt.objectId(),
    pickup: pickupInputSchema,
  }),
  output: z.object({}),
};
